module.exports = __webpack_public_path__ + "front/img/p9.ef3b1262.png";